import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getSlider(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/home/getSlider",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getActions(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/home/getActions",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getNumbers(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/home/geNumbers",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getNews(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/home/getNews",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getPortfolio(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/home/getPortfolio",
      reset,
    );
  },
});
